<template>
  <div class="container-step-1" v-show="step === 1">
    <div class="container-head">
      <img src="../assets/header/user.svg" alt="">
      Autenticazione
    </div>
    <div class="container-buttons">
      <button class="btn btn-custom">PIN</button>
      <button class="btn btn-custom btn-custom-spid">SPID</button>
      <button class="btn btn-custom">CIE</button>
      <button class="btn btn-custom">CNS</button>
    </div>
    <p>
      SPID è il sistema di accesso che consente di utilizzare, con un'identità digitale unica, i servizi online della
      Pubblica Amministrazione e dei privati accreditati. Se sei già in possesso di un'identità digitale, accedi con le
      credenziali del tuo gestore. Se non hai ancora un'identità digitale, richiedila ad uno dei gestori.
    </p>

    <b-dropdown right text="Entra con spid">
      <b-dropdown-item><img src="../assets/demo/download_1.png" alt=""></b-dropdown-item>
      <b-dropdown-item><img src="../assets/demo/download_2.png" alt=""></b-dropdown-item>
      <b-dropdown-item @click="step = 2"><img src="../assets/demo/download_3.png" alt=""></b-dropdown-item>
      <b-dropdown-item><img src="../assets/demo/download_4.png" alt=""></b-dropdown-item>
      <b-dropdown-item><img src="../assets/demo/download_5.png" alt=""></b-dropdown-item>
      <b-dropdown-item><img src="../assets/demo/download_6.png" alt=""></b-dropdown-item>
      <b-dropdown-item><img src="../assets/demo/download_7.png" alt=""></b-dropdown-item>
      <b-dropdown-item><img src="../assets/demo/download_8.png" alt=""></b-dropdown-item>
      <b-dropdown-item><img src="../assets/demo/download_9.png" alt=""></b-dropdown-item>
    </b-dropdown>

    <img src="../assets/demo/spid-agid-logo-lb.png" alt="">

    <!--    <button class="btn btn-custom btn-custom-spid btn-custom-spid-margin">Entra con spid</button>-->
  </div>
  <div class="container-step-2" v-show="step === 2">
    <div class="container-head container-head-poste">
      <img src="../assets/demo/logo-poste-italiane-medium.png" alt="">
    </div>

    <div class="container-login">
      <div class="container-head container-head-login">
        <img src="../assets/demo/logo-posteid-abspid.jpg" alt="">
      </div>
      <div class="container-content-login">
        <div class="container-content-login-left">
          <span>Login poste italiane</span>
          <span>Nome utente</span>
          <b-form-input type="text"></b-form-input>
          <span>Password</span>
          <b-form-input type="password"></b-form-input>
        </div>
        <div class="container-content-login-right">
          <img src="../assets/demo/qr.png" alt="">
        </div>
      </div>
      <button @click="setStep" class="btn btn-custom-poste">Login</button>
    </div>
  </div>
  <div v-show="step === 3" class="container-step-3">
    <div class="container-head container-head-login">
      <img src="../assets/demo/logo-posteid-abspid.jpg" alt="">
    </div>
    <div class="container-richiesta">
      <span v-show="timeout">Richiesta di accesso con SPID</span>
      <span v-show="timeout">Controlla il tuo smartphone</span>
      <div v-show="!timeout" style="display: flex;flex-direction: column">
        <p>
          Soraja <br>
          I seguenti dati stanno per essere inviati al fornitore dei servizi</p>
        <ul>
          <li> Codice identificativo</li>
          <li>Nome</li>
          <li>Cognome</li>
          <li>Luogo di nascita</li>
          <li>Data di nascita</li>
          <li>Sesso</li>
          <li>Codice fiscale</li>
          <li>Domicilio digitale</li>
          <li>Provincia di nascita</li>
          <li>Numero di telefono mobile</li>
          <li>Indirizzo di posta elettronica</li>
        </ul>
        <button style="margin-left: auto" class="btn btn-custom-poste" @click="finish" >Acconsento
        </button>
      </div>
    </div>
  </div>

</template>

<script>
import {useSettings} from "@/stores/settings";

export default {
  name: "fakeComponent",
  data() {
    return {
      timeout: true,
      step: 1
    }
  },
  created() {
  },
  methods: {
    finish() {
      useSettings().showFakeComponent = false
      this.emitter.emit('sendDetectIntent')
    },
    setStep() {
      this.step = 3
      setTimeout(() => {
        this.timeout = false
      }, 6000)
    }
  }
}
</script>

<style scoped>
.container-richiesta {
  display: flex;
  width: 60%;
  margin: auto;
  padding: 10px;
  justify-content: center;
  border: 1px solid grey;
  flex-direction: column;
}

.btn-custom-poste.btn {
  display: flex;
  background: #eedc00 !important;
  color: black !important;
}

.container-content-login-right img {
  margin: 0px auto;
}

.container-content-login-right {
  display: flex;
  width: 100%;
}

.container-content-login-left {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.container-content-login {
  display: flex;
  margin: 30px auto;
}

.container-head-login img {
  margin: 20px 0px;
}

.container-head-login {
  border-bottom: 1px solid;
}

.container-login {
  width: 60%;
  border: 1px solid grey;
  padding: 20px;
  margin: auto;
}

.container-head-poste img {
  margin: 0px auto;
}

.container-head-poste {
  position: sticky;
  top: 0;
  width: 100%;
  height: 10vh;
  background: #eedc00 !important;
}

:deep(.show.dropdown-menu) {
  width: 200px !important;
}

:deep(.dropdown-item) {
  margin: 15px 0px;
}

:deep(.dropdown-item) img {
  width: 100%;
}

.btn-custom-spid-margin.btn-custom-spid.btn-custom {
  margin-left: auto;
}

.btn-group {
  color: white !important;
  margin-left: auto !important;
  background-color: #517fef !important;
}

.btn-custom-spid.btn-custom {
  background: white;
  color: #517fef;
  margin: 10px 0px;
  border: 1px solid var(--color-light-grey);
}

.container-buttons {
  display: flex;
  width: 100%;
  align-items: center;
  border-bottom: 1px solid;
}

.container-head {
  display: flex;
  align-items: center;
}

.container-step-3 {

  background: white;
  display: flex;
  width: 100%;
  flex-direction: column;
}

.container-step-2 {
  background: white;
  display: flex;
  width: 100%;
  flex-direction: column;
}

.container-step-1 {
  display: flex;
  padding: 10px;
  flex-direction: column;
  border: 1px solid;
  align-items: center;
  justify-content: center;
  max-width: 60%;
  margin: auto;
}
</style>